<div class="sidebar collapse show navbar-collapse" id="navbarSupportedsidebar">
  <div class="list-group">
    <a [routerLink]="['/admin/new-dashboard']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module">
      <i class="fa-solid fa-house side_icon"></i>
      Dashboard
    </a>
    <!-- <a [routerLink]="['/feedback-manager-features']" class="list-group-item list-group-item-action" routerLinkActive="selected_module">
      <i class="fa-solid fa-star side_icon"></i>
      Feedback Manager
  </a> -->


    <a [routerLink]="['/admin/feedback-manager-sub']" id="feedbackurl" *ngIf="ending.end  != -1 || userType == 'Admin'"
      class="list-group-item list-group-item-action" routerLinkActive="selected_module">
      <i class="fa-solid fa-globe side_icon"></i>
      Feedback Manager
      <span style='  display: block; margin-top: -20px; text-align: center; font-weight: bold; '
        *ngIf="ending.end >= 0 && userType != 'Admin'"> ({{ending.end}} Days {{ending.title}})</span>
      <span style=' display: block; margin-top: -20px; text-align: center; font-weight: bold; '
        *ngIf="ending.end == -1 && userType != 'Admin'"> (Subscription required!)</span>
    </a>

    <!-- <a [routerLink]="['/feedback-manager-sub']" class="list-group-item list-group-item-action pl-5 " routerLinkActive="selected_module">
      <i class="fa-solid fa-globe side_icon"></i>
      Add URL
  </a> -->
    <span *ngIf="ending.end  != -1 || userType == 'Admin'">
      <a [routerLink]="['/admin/qr-review-upgrade-features']" class="list-group-item list-group-item-action"
        routerLinkActive="selected_module">
        <i class="fa-solid fa-star side_icon"></i>
        Feedback URL
      </a>
      <a class="list-group-item list-group-item-action pl-5 " *ngFor="let i of all_urls"
        (click)="open_feedback_url(i.url_name)" routerLinkActive="selected_module">
        <i class="fa-solid fa-globe side_icon"></i>
        {{ i.url_name }}
      </a>
    </span>
    <!-- <a [routerLink]="['/review-upgrade-features']" class="list-group-item list-group-item-action" routerLinkActive="selected_module">
      <i class="fa-regular fa-star side_icon"></i>
      Reviews</a>
  <a class="list-group-item list-group-item-action pl-5 " *ngFor="let i of all_urls" (click)="open_review_listing(i.url_name)" routerLinkActive="selected_module">
      <i class="fa-solid fa-globe side_icon"></i>
      {{ i.url_name }}
  </a> -->
    <!-- <a href="#submenu1" data-toggle="collapse" aria-expanded="false" class="list-group-item list-group-item-action flex-column align-items-start">
    <div class="d-flex w-100 justify-content-start align-items-center">
        <span class="fa fa-dashboard fa-fw mr-3"></span>
        <span class="menu-collapsed">Dashboard</span>
        <span class="submenu-icon ml-auto"></span>
    </div>
</a> -->
    <!-- Submenu content -->


    <a class="list-group-item list-group-item-action " href="#submenu1" data-toggle="collapse" aria-expanded="false"
      routerLinkActive="selected_module">
      <i class="fa-sharp fa-solid fa fa-shopping-cart side_icon"></i>
      Purchase Upgrades
      <span class="submenu-icon ml-auto"></span>
    </a>
    <div id='submenu1' class="collapse sidebar-submenu" routerLinkActive="show">
      <a [routerLink]="['/admin/purchase-upgrades']" class="list-group-item list-group-item-action pl-5 "
        routerLinkActive="selected_module">
        <i class="fa-brands fa-google"></i>
        Tokens
      </a>
      <a [routerLink]="['/admin/google-reviews']" class="list-group-item list-group-item-action pl-5 "
        routerLinkActive="selected_module">
        <i class="fa-brands fa-google"></i>
        Google Reviews
      </a>

      <a [routerLink]="['/admin/google-business']" class="list-group-item list-group-item-action pl-5 "
        routerLinkActive="selected_module">
        <i class="fa-sharp fa-solid fa-location-dot"></i>
        Google Business
      </a>

      <a [routerLink]="['/admin/map-booster']" class="list-group-item list-group-item-action pl-5 "
        routerLinkActive="selected_module">
        <i class="fa-solid fa-globe side_icon"></i>
        Map Pack Booster
      </a>
      <a [routerLink]="['/admin/sticker-design']" class="list-group-item list-group-item-action pl-5 "
        routerLinkActive="selected_module">
        <i class="fa-solid fa-globe side_icon"></i>
        Design, Printing & Display
      </a>
    </div>
    <!-- <a [routerLink]="['/instagram-reviews']" class="list-group-item list-group-item-action pl-5 " routerLinkActive="selected_module">
      <i class="fa-solid fa-globe side_icon"></i>
      Instagram Reviews
  </a> -->
    <!-- <a [routerLink]="['/twitter-reviews']" class="list-group-item list-group-item-action pl-5 " routerLinkActive="selected_module">
      <i class="fa-solid fa-globe side_icon"></i>
      Twitter Reviews
  </a> -->
    <a [routerLink]="['/admin/forms']" class="list-group-item list-group-item-action" routerLinkActive="selected_module">
      <i class="fa-solid fa-file side_icon"></i>
      Forms
    </a>
    <a [routerLink]="['/admin/review-info']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module">
      <i class="far fa-star"></i>
      Review Info
    </a>
    <a [routerLink]="['/admin/review_pending_complete']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
      <i class="fas fa-users"></i>
      Review Pending/Complete
    </a>

    <a [routerLink]="['/admin/review_pending_complete_additional']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
      <i class="fas fa-users"></i>
      Manual Reviews 1
    </a>

    <a [routerLink]="['/admin/manual-review-2']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
      <i class="fas fa-users"></i>
      Manual Reviews 2
    </a>

    <a [routerLink]="['/admin/manual-review-3']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
      <i class="fas fa-users"></i>
      Manual Reviews 3
    </a>


    <a [routerLink]="['/admin/mass-messaging']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
      <i class="fas fa-comments"></i>
      Mass Messaging
    </a>
    <!-- <a [routerLink]="['/bulk-email']" class="list-group-item list-group-item-action" routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
      <i class="fas fa-envelope"></i>
      Bulk Email
    </a> -->
    <a [routerLink]="['/admin/sub-admins']" class="list-group-item list-group-item-action" routerLinkActive="selected_module"
      *ngIf="userType == 'Admin'">
      <i class="fas fa-users"></i>
      Sub-admins
    </a>

    <a [routerLink]="['/admin/transactions']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
      <i class="fa fa-file"></i>
      Tranactions
    </a>
    <a [routerLink]="['/admin/diamond_transactions']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
      <i class="fa fa-file"></i>
      Diamond Tranactions
    </a>
    <a [routerLink]="['/admin/sub-trans']" class="list-group-item list-group-item-action" routerLinkActive="selected_module"
      *ngIf="userType == 'Admin'">
      <i class="fa fa-file"></i>
      Subscriptions
    </a>

    <a [routerLink]="['/admin/edit-profile']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module">
      <i class="fa-solid fa-gear side_icon"></i>
      Profile & Settings
    </a>
    <a [routerLink]="['/admin/addName']" class="list-group-item list-group-item-action" routerLinkActive="selected_module"
      *ngIf="userType == 'Admin'">
      <i class="fas fa-users"></i>
      Add Name
    </a>
    <a [routerLink]="['/admin/mapSearch']" class="list-group-item list-group-item-action" routerLinkActive="selected_module">
      <i class="fas fa-search"></i>
      Map Search
    </a>
    <a [routerLink]="['/admin/campaigns']" class="list-group-item list-group-item-action" routerLinkActive="selected_module">
      <i class="fa-solid fa-volume-high"></i>
      Campaigns
    </a>
    <a [routerLink]="['/admin/shop']" class="list-group-item list-group-item-action" routerLinkActive="selected_module">
      <i class="fa-solid fa-store"></i>
      Shop
    </a>
    <a [routerLink]="['/admin/vouchers',adminId]" class="list-group-item list-group-item-action pl-5 "
      routerLinkActive="selected_module">
      <img loading="lazy" height="16" width="18" src="../../../assets/images/discount-vouchers.svg" alt="">
      Vouchers
    </a>

    <a [routerLink]="['/admin/bookings']" class="list-group-item list-group-item-action" routerLinkActive="selected_module">
      <i class="fa-regular fa-calendar"></i>
      Bookings
    </a>

    <!-- Marketplace -->
    <a class="list-group-item list-group-item-action" href="#MarketplaceMenu" *ngIf="userType == 'Admin'"
      data-toggle="collapse" aria-expanded="false" routerLinkActive="selected_module">
      <i class="fa-sharp fa-solid fa fa-store side_icon"></i>
      Marketplace
      <span class="submenu-icon ml-auto"></span>
    </a>
    <div id='MarketplaceMenu' class="collapse sidebar-submenu" routerLinkActive="show">
      <a [routerLink]="['/admin/manage-member-roles']" class="list-group-item list-group-item-action pl-5"
        routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
        <i class="fa-solid fa-store"></i>
        Manage Roles
      </a>
      <a [routerLink]="['/admin/manage-market']" class="list-group-item list-group-item-action pl-5"
        routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
        <i class="fa-solid fa-store"></i>
        Manage Marketplace
      </a>
      <a [routerLink]="['/admin/manage-market-blog']" class="list-group-item list-group-item-action pl-5"
        routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
        <i class="fa-solid fa-store"></i>
        Marketplace Blog
      </a>
    </div>
    <!-- Marketplace -->

    <a [routerLink]="['/admin/orders']" class="list-group-item list-group-item-action" routerLinkActive="selected_module">
      <i class="fa-solid fa-store"></i>
      Orders
    </a>
    <a [routerLink]="['/admin/shop-summary']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
      <i class="fa fa-list-alt"></i>
      Shop Summary
    </a>
    <a [routerLink]="['/admin/members-analytics']" class="list-group-item list-group-item-action"
      routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
      <i class="fa-solid fa-line-chart"></i>
      Members Analytics
    </a>
    <!-- Forum -->
    <a class="list-group-item list-group-item-action" href="#forumMenu" *ngIf="userType == 'Admin'"
      data-toggle="collapse" aria-expanded="false" routerLinkActive="selected_module">
      <i class="fa-sharp fa-solid fa fa-comments side_icon"></i>
      Forum
      <span class="submenu-icon ml-auto"></span>
    </a>
    <div id='forumMenu' class="collapse sidebar-submenu" routerLinkActive="show">
      <a [routerLink]="['/admin/forum-categories']" class="list-group-item list-group-item-action pl-5"
        routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
        <i class="fa-solid fa-book"></i>
        Forum Categories
      </a>
      <a [routerLink]="['/admin/forum-polling']" class="list-group-item list-group-item-action pl-5"
        routerLinkActive="selected_module" *ngIf="userType == 'Admin'">
        <i class="fa-solid fa-book"></i>
        Forum Polling/Giveaway
      </a>
    </div>
    <!-- Forum -->
  </div>
</div>